import { render, staticRenderFns } from "./reportcgxm.vue?vue&type=template&id=8e759a3a&"
import script from "./reportcgxm.vue?vue&type=script&lang=js&"
export * from "./reportcgxm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports